import { t } from '@lingui/core/macro';
import { TFile } from 'components/Signup/hooks/useFileUploadReducer';
import { TFileStatusGroup } from 'types';

export const renderDocumentText = ({
  files,
  statusGroup,
  isUK,
}: {
  files: TFile[];
  statusGroup: TFileStatusGroup;
  isUK: boolean;
}): string => {
  // UK-only labels — never rendered under DE, so no translation needed.
  if (isUK) {
    switch (statusGroup) {
      case 'approved':
        return 'Approved';
      case 'rejected':
      case 'overridden':
        return 'Rejected';
      case 'uploaded':
      default:
        return 'Uploaded';
    }
  }

  const isPlural = files.length > 1;

  switch (statusGroup) {
    case 'approved':
      return isPlural ? t`Documents approved` : t`Document approved`;
    case 'rejected':
    case 'overridden':
      return isPlural ? t`Documents rejected` : t`Document rejected`;
    case 'uploaded':
    default:
      return isPlural ? t`Documents uploaded` : t`Document uploaded`;
  }
};
